// extracted by mini-css-extract-plugin
export default {"preqinReportLogo":"AppSpinner_preqinReportLogo__53rs8","logo":"AppSpinner_logo__Db7jF","fade-in":"AppSpinner_fade-in__9ADBT"};